import { UnwrapRef, ref, watch } from 'vue';
import i18n from '@/common/i18n';

/**
 * Utils for create "computed" locale object
 * The object will be automatically recalculated every time the locale changes.
 * example for usage:
 * const dictionary = computedLocale(() => ({
 *   one: i18n.t('one'),
 *   two: i18n.t('two'),
 *   three: i18n.t('three')
 * }));
 *
 * @param  {Function}        computed function for compute object
 * @return {Vue.observable}           result object will be use in components computed methods
 */
export default function computedLocale<T extends object>(computed: () => T): UnwrapRef<T> {
  const result = ref(computed());

  watch(() => i18n.locale, () => {
    Object.assign(result.value, computed());
  });

  return result.value;
}
